var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-row",
                    { attrs: { "no-margin": "" } },
                    [
                      _c("app-custom-language-select", {
                        staticClass: "mr",
                        style: { flexGrow: "1" },
                        attrs: { value: _vm.lang },
                        on: {
                          input: function ($event) {
                            return _vm.setLang($event)
                          },
                        },
                      }),
                      _c(
                        "w-button-bar",
                        [
                          _c(
                            "w-dropdown",
                            {
                              attrs: { items: _vm.buttonBarItems, right: "" },
                              on: {
                                click: function ($event) {
                                  return $event()
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "bars" } })],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-sortable",
            {
              attrs: {
                tag: "div",
                items: _vm.clientHeadingItems,
                "target-class": "handle",
              },
              on: {
                drop: function ($event) {
                  return _vm.onSorted()
                },
              },
            },
            _vm._l(_vm.clientHeadingItems, function (item, num) {
              return _c(
                "w-row",
                { key: num, staticClass: "value-button" },
                [
                  _c(
                    "w-col",
                    [
                      _c("w-fa", {
                        staticClass: "handle",
                        attrs: { icon: "ellipsis-v" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    [
                      _c("w-select", {
                        attrs: {
                          items: _vm.props,
                          label: _vm.$ct("line", { num: num + 1 }),
                          fancy: "",
                        },
                        model: {
                          value: item.Value,
                          callback: function ($$v) {
                            _vm.$set(item, "Value", $$v)
                          },
                          expression: "item.Value",
                        },
                      }),
                    ],
                    1
                  ),
                  item.Value == "FreeLine"
                    ? _c(
                        "w-col",
                        { staticClass: "shrink", attrs: { center: "" } },
                        [
                          _c(
                            "w-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.editFreeLine(item)
                                },
                              },
                            },
                            [_vm._v(" ... ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "w-col",
                    { staticClass: "shrink", attrs: { center: "" } },
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct(`tooltip.style-edit`),
                              expression: "$ct(`tooltip.style-edit`)",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.editStyle(item)
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { size: "lg", icon: "font" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
          _c("w-checkbox", {
            attrs: { label: _vm.$ct("isShown") },
            model: {
              value: _vm.heading.Show,
              callback: function ($$v) {
                _vm.$set(_vm.heading, "Show", $$v)
              },
              expression: "heading.Show",
            },
          }),
        ],
        1
      ),
      _vm.toEditStyleHeading
        ? _c(
            "w-modal",
            { attrs: { value: _vm.toEditStyleHeading != null } },
            [
              _c("app-style-editor", {
                attrs: { value: _vm.toEditStyleHeading.Style },
                on: {
                  input: function ($event) {
                    _vm.toEditStyleHeading.Style = $event
                  },
                  close: function ($event) {
                    _vm.toEditStyleHeading = null
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.toEditFreeLine
        ? _c(
            "w-modal",
            { attrs: { value: _vm.toEditFreeLine != null } },
            [
              _c(
                "w-card",
                { attrs: { "max-width": "500" } },
                [
                  _c("w-card-title", [
                    _vm._v(_vm._s(_vm.$ct("edit-free-line"))),
                  ]),
                  _c(
                    "w-card-content",
                    [
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-input", {
                                attrs: {
                                  label: _vm.$ct("free-line"),
                                  fancy: "",
                                },
                                model: {
                                  value: _vm.freeLineText,
                                  callback: function ($$v) {
                                    _vm.freeLineText = $$v
                                  },
                                  expression: "freeLineText",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-card-actions",
                    [
                      _c(
                        "w-button",
                        {
                          staticClass: "danger",
                          on: {
                            click: function ($event) {
                              _vm.toEditFreeLine = null
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
                      ),
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.confirmEditFreeLine()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$ct("common.confirm")) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("app-all-layouts-select", {
        attrs: {
          title: _vm.$ct("apply-heading-to-other-layouts"),
          show: _vm.allLayoutsSelectModalOpen,
          "confirm-handler": _vm.applyHeadingToOtherLayoutsHandler,
          "ignore-reminder-layouts": _vm.isDeliveryAddress,
        },
        on: {
          close: function ($event) {
            _vm.allLayoutsSelectModalOpen = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }